import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

const noop = () => {
};

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-distributionmode-dropdown',
  templateUrl: './DistributionModeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => DistributionModeDropdownComponent)}]
})
export class DistributionModeDropdownComponent extends BaseDropdownComponent {

    selectItems: SelectItem[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){
        this.domainDataService.getDistributionModes({IncludeInactive: false}).subscribe(x=> this.onGetDistributionModesDone(x));
    }
    
    onGetDistributionModesDone(items: ent.DistributionMode[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        this.value = this.selectedID;
    }

}